module.exports = __webpack_public_path__ + "img/arrow-right.ddfa4cf5.svg";